import { Outlet } from "react-router-dom";
import { Navigation } from "./Navigation";
import { FeedbackTab } from "@/components/FeedbackTab";

export function Layout() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="container mx-auto px-4 py-6 max-w-4xl">
        <Outlet />
      </main>
      <FeedbackTab />
    </div>
  );
}
